//主页面
const index = (r) => require.ensure([], () => r(require('@/components/home.vue')), 'index');

//发票汇总
const billList = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/financeCenter/payables/list.vue')),
    'payablesBillList'
  );
// 登记发票
const addBill = (r) =>
  require.ensure([], () => r(require('@/pages/financeCenter/payables/add.vue')), 'addBill');
const editBill = (r) =>
  require.ensure([], () => r(require('@/pages/financeCenter/payables/edit.vue')), 'editBill');
const detailBill = (r) =>
  require.ensure([], () => r(require('@/pages/financeCenter/payables/detail.vue')), 'detailBill');

const creditRouter = {
  path: '/payables',
  component: index,
  children: [
    {
      path: 'billList',
      name: 'payablesBillList',
      component: billList,
      meta: {
        keepAlive: true,
        title: '应付发票汇总',
      },
    },
    {
      path: 'addBill',
      name: 'addBill',
      component: addBill,
      meta: {
        keepAlive: true,
        title: '应付发票登记',
      },
    },
    {
      path: 'editBill',
      name: 'editBill',
      component: editBill,
      meta: {
        keepAlive: true,
        title: '应付发票修改',
      },
    },
    {
      path: 'detailBill',
      name: 'detailBill',
      component: detailBill,
      meta: {
        keepAlive: true,
        title: '应付发票详情',
      },
    },
  ],
};
export default creditRouter;
